import { createApp } from 'vue'
import App from './app/App.vue'
import store from "./store/store"
import router from "./route/route"
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import useQweField from "./components/useFields"
import useFilters from "./components/Filters/useFilters"
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import "animate.css"
import initApp from './utils/initApp/initApp'
import "./index.css"



let QweApp = function(verification:string,baseUrl:string){
    store.commit("SetVerification", verification);
    store.commit("SetBaseUrl", baseUrl);
    store.commit("setRuntimeDev", false);

    const app = createApp(App);
    app.use(store)
        .use(router)
        .use(ElementPlus,{
            locale: zhCn
        })
        .use(initApp)
        .use(useQweField)
        .use(useFilters)
        .mount('#app')
}


let QweInstallNoneApp = function(verification:string,baseUrl:string){
    store.commit("SetVerification", verification);
    store.commit("SetBaseUrl", baseUrl);
}


window.QweInstallNoneApp = QweInstallNoneApp;
window.QweInstallApp = QweApp;


if(import.meta.env.DEV){
    QweApp("","");
}